export default __webpack_public_path__ + "locales/el-GR/Translations.json?hash=426e0aecbe2772bcae170e0f348a7157";